import EmailAddress from "_shared/email-addresses/email-address";
import Guid from "_shared/guids/guid";

export default class IndividualSummary {
  public readonly id: Guid;
  public readonly userId: Guid;
  public readonly firstName: string;
  public readonly lastName: string;
  public readonly avatarId?: Guid;
  public readonly emailAddress?: EmailAddress;

  public constructor(
    id: Guid, 
    userId: Guid, 
    firstName: string, 
    lastName: string, 
    avatarId?: Guid, 
    emailAddress?: EmailAddress
  ) {
    this.id = id;
    this.userId = userId;
    this.firstName = firstName;
    this.lastName = lastName;
    this.avatarId = avatarId;
    this.emailAddress = emailAddress;
  }
}
